// #165 — the retired Storyboard routes (/storyboard, /story, /story-v3) land
// on Present. The query string is kept so a public-link `?token=` still works.
import { Navigate, useLocation, useParams } from "react-router-dom";

export default function RedirectToPresent() {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/analyses/${id}/present${search}`} replace />;
}
